import { IconButton, styled } from '@chronosphereio/chrono-ui';
import { hexToRgba } from '@chronosphereio/core';

/**
 * Icon button that tints its background with a 25%-opacity version of
 * `iconColor` when `isSelected` is true. Used by the threshold/color picker
 * triggers so the swatch icon's color also previews as the button highlight.
 */
export const ColorIconButton = styled(IconButton, {
  shouldForwardProp: (props) => props !== 'isSelected' && props !== 'iconColor',
})<{
  iconColor?: string;
  isSelected?: boolean;
}>(({ iconColor, isSelected }) => ({
  backgroundColor: isSelected && iconColor ? hexToRgba(iconColor, 0.25) : 'transparent',
  color: iconColor,
}));
